import React from 'react'
import { Text } from 'rsuite'
import HTLoader from '../../../assets/HT-loader.gif'
import './Loader.scss'

const Loader: React.FC = () => {
  return (
    <div className="loader-backdrop" data-testid="loader">
      <div className="loader">
        <img src={HTLoader} alt="Loading..." />
      </div>
      <Text size="lg">Loading, please wait...</Text>
    </div>
  )
}

export default Loader
